import {gettext} from 'topmeteo/utils/i18n';

import {changeProduct} from '../actionCreators';
import {getNextProduct, getPreviousProduct} from '../../general/selectors';

import Button from './ChangeImageButton';

const NextLabel = gettext('next product');
const PreviousLabel = gettext('previous product');

const Buttons = [
    {id: 'top', label: PreviousLabel, action: getPreviousProduct},
    {id: 'bottom', label: NextLabel, action: getNextProduct},
];

const SwitchProduct = () => Buttons.map(({id, label, action}) => (
    <Button key={id} className={id} label={label} action={action} change={changeProduct} />
));

export default SwitchProduct;
